export const UI_CONFIGURATION = 'ui_config';
export const LEAKED_CREDENTIALS = 'leaked_credentials_configuration';
